import { TAG_EXTRA_LESSONS } from '../config/leckeszam';
import { DISCORD_SERVER_URL } from '../config/links';

/* ══════════════════════════════════════════════════════════════════════════
   „A FIÓKODHOZ TARTOZIK MÉG” — a /tanfolyamok extrái és az üdvözlő kártya (navigáció 1. kör)
   ─────────────────────────────────────────────────────────────────────────
   A kártyák a get_user_access szerint igazodnak (a szintek és a keretek nem változnak):
   a nyitott kártya oda visz, ahol a funkció van (terminál, a landing segédletei, az egyetem
   felismerői, a dashboard Discord-csempéje, a bónuszok), a zárt egy sorban mondja meg, mi nyitja.
   A feliratok a landing dashboardjáéi (DashboardPage.jsx), ahol már vannak.
   Tiszta függvények, hogy Jesttel tesztelhetők legyenek; a megjelenítés: components/courses/AccountExtras.js.
   ══════════════════════════════════════════════════════════════════════════ */

/** A szint a get_user_access alapján: pro | plusz | tag | free (a próba a tananyagra FREE). */
export function szintje(access) {
  const t = access?.tier;
  if (t === 'pro') return 'pro';
  if (t === 'plusz') return 'plusz';
  if (t === 'affiliate' || t === 'tag') return 'tag';
  return 'free';
}

/**
 * A kártyák sorrendben. Mindegyik: { cel, cim, sor, nyitott, gombok: [{ felirat, cel, hova }] }.
 * hova: { tipus: 'terminal' | 'landing' | 'route' | 'href' | 'kulso', path }. Zárt kártyán nincs gomb.
 * opts.discordOsszekotve: a profil discord_user_id-je (összekötött fióknál „Belépek →” a Discordra, mint a dashboardon).
 */
export function extrak(access, { discordOsszekotve = false } = {}) {
  if (!access) return [];
  const szint = szintje(access);
  const pro = szint === 'pro';
  const pluszVagyPro = szint === 'plusz' || pro;
  const tagVagyFelette = szint !== 'free';
  const proba = Boolean(access.trial_active) && !pro;
  const lista = [];

  lista.push({
    cel: 'terminal', cim: 'Kripto Terminál', nyitott: true,
    sor: pro ? 'PRO – minden fül' : proba ? `PRO-próba – még ${access.trial_days_left ?? 0} nap`
      : szint === 'plusz' ? 'Plusz – Szkenner, RSI, Funding' : 'Ingyenes alapfunkciók',
    gombok: [{ felirat: 'Megnyitom →', cel: 'terminal', hova: { tipus: 'terminal', path: '/' } }],
  });
  lista.push({
    cel: 'segedletek', cim: 'Segédletek', nyitott: true,
    sor: 'Puskák, ellenőrzőlisták, kitölthető tervezőlapok.',
    gombok: [{ felirat: 'Megnyitom →', cel: 'segedletek', hova: { tipus: 'landing', path: '/segedletek' } }],
  });
  lista.push({
    cel: 'gyakorlok', cim: 'Gyakorlók', nyitott: true,
    sor: pluszVagyPro ? 'Alakzatfelismerő és Gyertyaminta-felismerő: minden feladat nyitva.'
      : 'Alakzatfelismerő és Gyertyaminta-felismerő: 12–12 feladat ingyen.',
    gombok: [
      { felirat: 'Alakzatfelismerő →', cel: 'alakzatfelismero', hova: { tipus: 'route', path: '/alakzatfelismero' } },
      { felirat: 'Gyertyaminta-felismerő →', cel: 'gyertyafelismero', hova: { tipus: 'route', path: '/gyertyafelismero' } },
    ],
  });
  lista.push(tagVagyFelette
    ? { cel: 'discord', cim: pro ? 'PRO Discord' : 'TAG Discord', nyitott: true,
        sor: pro ? 'A PRO-csatorna: piaci kérdések, közös tanulás, heti áttekintés.' : 'Piaci kérdések, közös tanulás, heti áttekintés.',
        gombok: [discordOsszekotve
          ? { felirat: 'Belépek →', cel: 'discord', hova: { tipus: 'kulso', path: DISCORD_SERVER_URL } }
          : { felirat: 'Összekötöm a dashboardon →', cel: 'discord_osszekotes', hova: { tipus: 'landing', path: '/dashboard' } }] }
    : { cel: 'discord', cim: 'Discord', nyitott: false, sor: 'TAG aktiválással nyílik', gombok: [] });
  lista.push(access.has_napi_osszefoglalo || access.has_pro_hirlevel
    ? { cel: 'hirlevel', cim: 'Heti hírlevél', nyitott: true, sor: 'Feliratkozva · minden pénteken', gombok: [] }
    : { cel: 'hirlevel', cim: 'Heti hírlevél', nyitott: false, sor: 'Heti hírlevél a TAG-gal', gombok: [] });
  lista.push({
    cel: 'bonusz', cim: 'Bónuszok', nyitott: true,
    sor: 'A partnertőzsdék aktuális ajánlatai egy helyen.',
    gombok: [{ felirat: 'Megnézem →', cel: 'bonusz', hova: { tipus: 'href', path: 'https://web3kurzus.hu/bonusz' } }],
  });
  if (szint === 'free') {
    lista.push({
      cel: 'tag', cim: 'TAG-aktiválás', nyitott: true,
      sor: `Még ${TAG_EXTRA_LESSONS} lecke a Kripto Startból, heti hírlevél és Discord a TAG-gal.`,
      gombok: [{ felirat: 'Aktiválás →', cel: 'tag', hova: { tipus: 'landing', path: '/dashboard?tag=aktivalas' } }],
    });
    if (access.trial_state === 'nincs') {
      lista.push({
        cel: 'proba', cim: '14 nap PRO-terminál', nyitott: true,
        sor: 'Egyszer indítható. Bankkártya nem kell, és a végén nem indul előfizetés.',
        gombok: [{ felirat: 'A dashboardon indítom →', cel: 'proba', hova: { tipus: 'landing', path: '/dashboard' } }],
      });
    }
  }
  return lista;
}

/** Az üdvözlő kártya 3–4 legfontosabb extrája a szint szerint (a nyitottakból). */
export function udvozloExtrak(access, opts) {
  const l = extrak(access, opts);
  const by = (c) => l.find(x => x.cel === c);
  const sor = szintje(access) === 'free'
    ? ['terminal', 'segedletek', 'gyakorlok', 'tag']
    : ['terminal', 'segedletek', 'discord', 'gyakorlok'];
  return sor.map(by).filter(x => x && x.nyitott);
}

/* ── Üdvözlő kártya: legfeljebb az első három látogatáson, bezárás után soha ──
   Tárolás: a böngészőben (localStorage, fiókonként). A profiles táblában nincs erre alkalmas mező
   (csak két *_prompt_dismissed_at időbélyeg; a látogatásszámhoz új oszlop és a protect_profile_fields
   trigger módosítása kellene), beállítástábla sincs a felhasználói felülethez. Egy látogatás = egy
   böngészőmunkamenet (sessionStorage-jelölő), így az oldalak közti lépkedés nem számít újnak. */
export const UDVOZLO_KULCS = 'w3k_egyetem_udvozlo';
export const UDVOZLO_MAX = 3;

function olvas(storage, uid) {
  try { return JSON.parse(storage?.getItem(UDVOZLO_KULCS) || '{}')[uid] || { latogatas: 0, bezarva: false }; } catch { return { latogatas: 0, bezarva: false }; }
}
function ir(storage, uid, v) {
  try {
    const all = JSON.parse(storage?.getItem(UDVOZLO_KULCS) || '{}');
    all[uid] = v;
    storage?.setItem(UDVOZLO_KULCS, JSON.stringify(all));
  } catch { /* ha nincs tárhely, a kártya csak ebben a munkamenetben látszik */ }
}

/** Egy /tanfolyamok-megnyitás: munkamenetenként egyszer növeli a látogatásszámot; true, ha a kártya látszik. */
export function udvozloLatogatas(uid, { local = safe('localStorage'), session = safe('sessionStorage') } = {}) {
  if (!uid) return false;
  const v = olvas(local, uid);
  if (v.bezarva) return false;
  let jel = null;
  try { jel = session?.getItem(`${UDVOZLO_KULCS}_${uid}`); } catch { /* */ }
  if (!jel) {
    v.latogatas += 1;
    ir(local, uid, v);
    try { session?.setItem(`${UDVOZLO_KULCS}_${uid}`, '1'); } catch { /* */ }
  }
  return v.latogatas <= UDVOZLO_MAX;
}

export function udvozloBezaras(uid, { local = safe('localStorage') } = {}) {
  if (!uid) return;
  ir(local, uid, { ...olvas(local, uid), bezarva: true });
}

function safe(name) {
  try { return typeof window !== 'undefined' ? window[name] : null; } catch { return null; }
}
